module.exports = __webpack_public_path__ + "static/media/buy_req_rent_7.34792a44.png";